import SEO from '../components/SEO.jsx';
import Hero from '../components/sections/Hero.jsx';
import CoreFeatures from '../components/sections/CoreFeatures.jsx';
import Services from '../components/sections/Services.jsx';
import About from '../components/sections/About.jsx';
import WhyChooseUs from '../components/sections/WhyChooseUs.jsx';
import WorkProcess from '../components/sections/WorkProcess.jsx';
import CaseStudies from '../components/sections/CaseStudies.jsx';
import Testimonials from '../components/sections/Testimonials.jsx';
import CTA from '../components/sections/CTA.jsx';
import Stats from '../components/sections/Stats.jsx';

const Home = () => {
  const homeStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Sutrasync",
    "url": "https://sutrasync.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://sutrasync.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Sutrasync",
      "logo": {
        "@type": "ImageObject",
        "url": "https://sutrasync.com/logo.png"
      }
    }
  };

  return (
    <>
      <SEO 
        title="Best Web & App Development Company | Digital Marketing in bengalore"
        description="Expert web & mobile app developers in India's tech hub. 500+ projects delivered with 98% satisfaction. React Native, Flutter, digital marketing. Free consultation - Call +91 7483961283!"
        keywords="web development company, app development services, digital marketing agency, mobile app developers, software company, IT services, website design, professional web development, custom software solutions, business website development, Bengaluru, Karnataka"
        url="https://sutrasync.com/"
        image="https://sutrasync.com/logo.png"
        structuredData={homeStructuredData}
      />
      
      <Hero />
      <CoreFeatures />
      <Services />
      <About />
      <WhyChooseUs />
      <WorkProcess />
      <Stats />
      <CaseStudies />
      <Testimonials />
      {/* <CTA /> */}
    </>
  );
};

export default Home;